import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import TableBuyOrders from '../../../../../../specificComponents/buys/TableBuyOrders'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateBuyOrder from './ModalCreateBuyOrder'

interface BuyOrdersProps extends ComponentWithPermissions { }

const BuyOrders: React.FC<BuyOrdersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('buyOrders', 'Pedidos'),
        newText: t('newBuyOrder', 'Nuevo pedido'),
    }
    return (
        <BaseScreenTable TableComponent={TableBuyOrders} CreateModalComponent={ModalCreateBuyOrder} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default BuyOrders